export async function initTokenLogin(element) {
    const url = element.dataset.tokenLoginUrl;
    if (!url) {
        return;
    }

    const response = await fetch(url, {
        method: 'POST',
    });

    if (response.redirected === true) {
        window.location.replace(response.url);
    }
}
